module.exports = __webpack_public_path__ + "img/default-logo.ef4feba7.png";